module.exports = __webpack_public_path__ + "img/solution-data-advantage1.17b2a799.svg";